import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
export var Locale = /*#__PURE__*/function (Locale) {
  Locale["English"] = "en";
  Locale["Spanish"] = "es";
  return Locale;
}({});
var localeNames = _defineProperty(_defineProperty({}, Locale.English, 'English'), Locale.Spanish, 'Español');
export var getLocaleName = function getLocaleName(locale) {
  return localeNames[locale] || locale;
};
export var getPrismicLocale = function getPrismicLocale(locale) {
  switch (locale) {
    case Locale.Spanish:
      return 'es-es';
    case Locale.English:
    default:
      return undefined;
    // default to english (actually en-au)
  }
};
var English = Locale.English,
  otherLocales = _objectWithoutProperties(Locale, ["English"]);
export var nonEnglishLocales = Object.values(otherLocales);